<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import ServerStatusOffline from '@/layout/ServerStatusOffline.vue';
import AppBootSkeleton from '@/layout/AppBootSkeleton.vue';
import { shouldShowAppBootSkeleton } from '@/layout/appBootState.js';
import { useAuthState } from '@/composables/authState.js';

const route = useRoute();
const { isUnknown } = useAuthState();
const showBootSkeleton = computed(() => shouldShowAppBootSkeleton({
    authUnknown: isUnknown.value,
    routePath: route.path,
    browserPath: typeof window === 'undefined' ? '' : window.location.pathname
}));
</script>

<template>
    <AppBootSkeleton v-if="showBootSkeleton" />
    <router-view v-else />
    <ServerStatusOffline />
</template>

<style scoped></style>
